(() => {
  const configElement = document.getElementById('faf-search-config');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const strings = config.strings || {};
  const types = (config.types || []).filter(Boolean);
  const quote = value => '"' + String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  const group = values => '(' + [...new Set(values)].join(' OR ') + ')';
  const field = (name, value) => name + ':' + quote(value);
  const attribute = (name, values, variant = false) => group(values.flatMap(value => [
    field('tag', name + ':' + value), field('tag', name + '_' + value.replace(/\s+/g, '')),
    field('tag', name + '_' + value), ...(variant ? [field('variants.title', value)] : [])
  ]));
  const outdoorWords = 'outdoors?|outside|patios?|back[ -]?yards?|porch(?:es)?|balcon(?:y|ies)|terraces?|pool[ -]?side|alfresco|al[ -]fresco|open[ -]air|all[ -]weather|weather[ -]resistant|weatherproof';
  const outdoorTerms = new RegExp('\\b(?:' + outdoorWords + '|(?:garden|deck|lawn)(?=\\s+(?:furniture|sets?|seating|chairs?|sofas?|sectionals?|tables?|dining|benches|bench|loungers?)\\b))\\b|\\b(?:for|on)\\s+(?:(?:the|my|our|a)\\s+)?(?:garden|deck|lawn)\\b', 'ig');
  const outdoorNegations = new RegExp('\\b(?:no|not|without|exclude|excluding|non)[ -]+(?:' + outdoorWords + '|garden|deck|lawn)(?:\\s+furniture)?\\b|(?:^|\\s)-(?:' + outdoorWords + '|garden|deck|lawn)\\b', 'ig');
  const outdoorFields = [
    ...['Outdoor', 'Category:Outdoor', 'Category_Outdoor', 'Patio', 'Category:Patio', 'Category_Patio'].map(value => field('tag', value)),
    field('product_type', 'outdoor'), field('product_type', 'patio'),
    field('title', 'outdoor'), field('title', 'patio')
  ];
  const colorRules = [
    [/\bdark\s+gr[ae]y\b/i, ['Dark Gray']], [/\blight\s+gr[ae]y\b/i, ['Light Gray']],
    [/\bdark\s+brown\b/i, ['Dark Brown']], [/\blight\s+brown\b/i, ['Light Brown']],
    [/\bdark\s+red\b/i, ['Dark Red']], [/\bdark\s+green\b/i, ['Dark Green']],
    [/\bdark\s+blue\b/i, ['Dark Blue']], [/\blight\s+green\b/i, ['Light Green']],
    [/\blight\s+blue\b/i, ['Light Blue']], [/\bred\b/i, ['Red', 'Dark Red']],
    [/\bblack\b/i, ['Black']], [/\bwhite\b/i, ['White']],
    [/\bgr[ae]y\b/i, ['Gray', 'Dark Gray', 'Light Gray']],
    [/\bblue\b/i, ['Blue', 'Light Blue', 'Dark Blue']],
    [/\bgreen\b/i, ['Green', 'Dark Green', 'Light Green']],
    [/\bbrown\b/i, ['Brown', 'Dark Brown', 'Light Brown']],
    [/\bbeige\b/i, ['Beige']], [/\bpink\b/i, ['Pink']], [/\bpurple\b/i, ['Purple']],
    [/\borange\b/i, ['Orange']], [/\byellow\b/i, ['Yellow']], [/\bivory\b/i, ['Ivory']],
    [/\bcream\b/i, ['Cream']], [/\btan\b/i, ['Tan']], [/\bburgundy\b/i, ['Burgundy', 'Dark Red']]
  ];
  const typeRules = [
    [/\b(?:sofa|console)\s+tables?\b/i, /\b(?:Sofa|Console) Tables?\b/i, 'Console tables'],
    [/\bcoffee\s+tables?\b/i, /\b(?:Coffee|Cocktail) Tables?\b/i, 'Coffee tables'],
    [/\b(?:end|side)\s+tables?\b/i, /\b(?:End|Side|Chair Side|Accent) Tables?\b/i, 'End tables'],
    [/\bdining\s+(?:room\s+)?(?:sets?|tables?)\b/i, /\bDining (?:Room Sets?|Sets?|Tables?(?: with Extensions)?)$/i, 'Dining furniture'],
    [/\bbedroom\s+(?:sets?|packages?)\b/i, /\bBedroom Sets?$/i, 'Bedroom sets'],
    [/\b(?:tv|television)\s+stands?\b/i, /\b(?:TV Stands?|Entertainment Centers?)$/i, 'TV stands'],
    [/\b(?:sleeper|sofa)\s+beds?\b|\bsleeper\s+(?:sofas?|couches?)\b/i, /\bSleeper (?:Sofas?|Sectionals?)$/i, 'Sleeper sofas'],
    [/\bsectionals?(?:\s+sofas?)?\b/i, /\bSectionals?$/i, 'Sectionals'],
    [/\b(?:loveseats?|love\s+seats?)\b/i, /\b(?:Stationary |Reclining )?Loveseats?$/i, 'Loveseats'],
    [/\b(?:sofas?|couch|couches)\b/i, /^(?:(?:Stationary|Reclining|Sleeper) )?Sofas?$/i, 'Sofas'],
    [/\bmattress(?:es)?\b/i, /\bMattress(?:es)?$/i, 'Mattresses'],
    [/\brecliners?\b/i, /\b(?:Recliners?|Reclining Chairs?)$/i, 'Recliners'],
    [/\bnight\s?stands?\b/i, /\bNightstands?$/i, 'Nightstands'],
    [/\bdressers?\b/i, /\bDressers?(?: & Mirrors?)?$/i, 'Dressers'],
    [/\b(?:bed\s+frames?|beds?)\b/i, /\bBeds?$/i, 'Beds'],
    [/\b(?:bar\s+stools?|counter\s+stools?)\b/i, /\b(?:Bar Stools?|Counter Stools?|Counter Height|Bar Height)/i, 'Bar stools'],
    [/\b(?:accent\s+)?chairs?\b/i, /\bChairs?$/i, 'Chairs'],
    [/\b(?:ottomans?|footstools?)\b/i, /\bOttomans?$/i, 'Ottomans'],
    [/\b(?:rugs?|carpets?)\b/i, /\bRugs?$/i, 'Rugs']
  ];
  function buildPlan(input) {
    const query = String(input || '').replace(/\s+/g, ' ').trim().slice(0, 180);
    const result = { query, engineQuery: query, productIntent: true, types: [], colors: [], sizes: [], labels: [], alternativeQuery: '' };
    if (!query || /\b(?:financ(?:e|ing)|delivery|layaway|showrooms?|store hours|contact|return policy|about us)\b/i.test(query)) {
      result.productIntent = false;
      return result;
    }
    if (/\b(?:title|tag|product_type|vendor|variants\.[\w]+):/i.test(query)) return result;
    let remaining = query.replace(/\bgrey\b/ig, 'gray');
    const clauses = [];
    let matchedTypes = [];
    for (const [pattern, typePattern, label] of typeRules) {
      if (!pattern.test(remaining)) continue;
      matchedTypes = types.filter(type => typePattern.test(type));
      if (!matchedTypes.length) continue;
      result.alternativeQuery = remaining.match(pattern)[0];
      remaining = remaining.replace(pattern, ' ');
      result.types = matchedTypes;
      result.labels.push(label);
      clauses.push(group(matchedTypes.map(type => field('product_type', type))));
      break;
    }
    if (matchedTypes.length) {
      const modular = remaining.match(/\bmodular\b/i);
      if (modular) {
        clauses.push(group(['title', 'body', 'tag', 'product_type', 'variants.title', 'variants.sku'].map(name => field(name, 'modular'))));
        result.labels.push('Modular');
        remaining = remaining.replace(/\bmodular\b/ig, ' ');
      }
      for (const [pattern, values] of colorRules) {
        const match = remaining.match(pattern);
        if (!match) continue;
        result.colors = values;
        result.labels.unshift(match[0].replace(/\b\w/g, value => value.toUpperCase()));
        remaining = remaining.replace(pattern, ' ');
        clauses.push(attribute('Color', values, true));
        break;
      }
      if (matchedTypes.some(type => /\b(?:Mattress(?:es)?|Beds?)$/i.test(type))) {
        const size = remaining.match(/\b(california king|cal king|twin xl|twin extra long|queen|king|full|double|twin)\b(?:[ -]+sized?\b)?/i);
        if (size) {
          const canonical = { 'cal king': 'California King', 'california king': 'California King', 'twin xl': 'Twin XL', 'twin extra long': 'Twin XL', double: 'Full' }[size[1].toLowerCase()] || size[1].replace(/\b\w/g, value => value.toUpperCase());
          result.sizes = [canonical];
          result.labels.unshift(canonical);
          remaining = remaining.replace(size[0], ' ');
          clauses.push(attribute('Size', result.sizes, true));
        }
      }
      const material = remaining.match(/\b(faux leather|vegan leather|genuine leather|leather|fabric|velvet|corduroy)\b/i);
      if (material) {
        const raw = material[0].toLowerCase();
        const value = raw === 'genuine leather' ? 'Leather' : raw.replace(/\b\w/g, char => char.toUpperCase());
        const values = raw === 'vegan leather' ? ['Faux Leather', 'Vegan Leather'] : [value];
        const tagClause = attribute('Material', values);
        clauses.push(raw === 'leather' || raw === 'genuine leather' ? tagClause : group([tagClause, field('title', value)]));
        result.labels.push(value);
        remaining = remaining.replace(material[0], ' ');
      }
    }
    if (!matchedTypes.length) {
      // Keep model/name spellings ahead of Shopify's typo alternatives. This
      // optional query is used only when it actually finds matching products.
      const words = remaining.trim().split(/\s+/).filter(Boolean);
      if (words.length && words.length <= 6 && words.every(word => /^[\p{L}\p{N}][\p{L}\p{N}'’-]*$/u.test(word)) &&
        !words.some(word => /^(?:AND|OR|NOT)$/.test(word))) {
        result.literalEngineQuery = words.map(quote).join(' AND ');
        if (words.length === 1 && /^[\p{L}]{5,30}$/u.test(words[0])) result.spellingTerm = words[0];
      }
      return result;
    }
    const tokens = remaining.match(/"[^"]+"|[^\s]+/g) || [];
    const stopwords = new Set(['a', 'an', 'the', 'for', 'in', 'with', 'and', '&']);
    const terms = tokens.map(token => token.replace(/^"|"$/g, '')).filter(token => !stopwords.has(token.toLowerCase()));
    for (const term of terms) {
      const values = [term];
      if (/^gr[ae]y$/i.test(term)) values.push('gray', 'grey');
      clauses.push(group(values.flatMap(value => ['title', 'product_type', 'vendor', 'variants.title', 'variants.sku'].map(name => field(name, value)))));
    }
    if (clauses.length) result.engineQuery = clauses.join(' AND ');
    return result;
  }
  function plan(input) {
    const query = String(input || '').replace(/\s+/g, ' ').trim().slice(0, 180);
    if (!query) return buildPlan(query);
    let excludedOutdoor = false;
    const withoutNegations = query.replace(outdoorNegations, () => {
      excludedOutdoor = true;
      return ' ';
    });
    const outdoorIntent = !excludedOutdoor && Boolean(withoutNegations.match(outdoorTerms));
    const fieldQuery = /\b(?:title|body|tag|product_type|vendor|variants\.[\w]+):/i.test(withoutNegations);
    const scopedTerms = outdoorIntent && !fieldQuery ? withoutNegations.replace(outdoorTerms, ' ').replace(/\bfurniture\b/ig, ' ') : withoutNegations;
    const remaining = (!outdoorIntent && !fieldQuery ? scopedTerms.replace(/\bindoors?\b/ig, ' ') : scopedTerms).replace(/\s+/g, ' ').trim();
    const result = buildPlan(remaining || '*');
    result.query = query;
    result.outdoorIntent = outdoorIntent;
    const scope = outdoorIntent ? group(outdoorFields) : outdoorFields.map(clause => '-' + clause).join(' AND ');
    result.engineQuery = scope + (remaining ? ' AND (' + result.engineQuery + ')' : '');
    if (result.literalEngineQuery) result.literalEngineQuery = scope + ' AND (' + result.literalEngineQuery + ')';
    if (result.spellingTerm) result.spellingScope = scope;
    if (outdoorIntent) {
      result.labels.unshift('Outdoor');
      if (result.alternativeQuery) result.alternativeQuery = 'outdoor ' + result.alternativeQuery;
    }
    return result;
  }
  function toEngineParams(humanParams) {
    const params = new URLSearchParams(humanParams);
    const intent = plan(params.get('q'));
    params.set('q', intent.engineQuery);
    params.set('options[prefix]', 'last');
    if (intent.types.length) {
      params.delete('filter.p.product_type');
      intent.types.forEach(type => params.append('filter.p.product_type', type));
    }
    if (intent.colors.length) params.delete('filter.v.option.color');
    if (intent.sizes.length) params.delete('filter.v.option.size');
    if (intent.productIntent) params.set('type', 'product');
    else params.delete('type');
    return params;
  }
  function suggestionsURL(query) {
    const params = toEngineParams(new URLSearchParams({ q: query }));
    params.set('section_id', 'faf-search-suggestions');
    return config.searchUrl + '?' + params;
  }
  function normalize(root, humanQuery, intent = plan(humanQuery)) {
    const countElement = root.querySelector('[data-faf-search-count]');
    const count = Number(countElement?.dataset.fafSearchCount);
    const correction = root.dataset?.fafSearchCorrection || countElement?.dataset.fafSearchCorrection || '';
    root.querySelectorAll('[data-faf-search-correction-message]').forEach(element => {
      element.hidden = !correction;
      element.textContent = correction ? (strings.correctedQuery || 'Showing results for “{query}”.').replace('{query}', correction) : '';
    });
    root.querySelectorAll('input[name="q"]').forEach(input => { input.value = humanQuery; input.setAttribute('value', humanQuery); });
    root.querySelectorAll('.main-page-title').forEach(heading => { heading.textContent = strings.heading + ': ' + humanQuery; });
    root.querySelectorAll('.search__form-text').forEach(element => element.remove());
    if (Number.isFinite(count)) {
      const countText = (count === 1 ? strings.oneResult : strings.results).replace('{count}', count).replace('{query}', humanQuery);
      root.querySelectorAll('#ProductCount,#ProductCountDesktop,.facets__product-count,[data-faf-search-live-count]').forEach(element => { element.textContent = countText; });
    }
    root.querySelectorAll('a[href]').forEach(anchor => {
      let url;
      try { url = new URL(anchor.getAttribute('href'), location.origin + config.searchUrl); } catch { return; }
      if (url.origin !== location.origin || url.pathname !== config.searchUrl || !url.searchParams.has('q')) return;
      url.searchParams.set('q', humanQuery);
      url.searchParams.delete('section_id');
      if (intent.types.length) url.searchParams.delete('filter.p.product_type');
      anchor.setAttribute('href', url.pathname + '?' + url.searchParams);
    });
    root.querySelectorAll('[data-faf-search-query]').forEach(element => { element.textContent = humanQuery; });
    root.querySelectorAll('[data-faf-search-summary]').forEach(element => {
      element.textContent = intent.labels.length ? strings.matching + ' ' + intent.labels.join(' · ') : '';
      element.hidden = !intent.labels.length;
    });
    root.querySelectorAll('[data-faf-search-heading]').forEach(element => { element.textContent = intent.productIntent ? strings.matchingProducts : strings.matchingResults; });
    const lockedFilters = [...(intent.types.length ? ['filter.p.product_type'] : []), ...(intent.colors.length ? ['filter.v.option.color'] : []), ...(intent.sizes.length ? ['filter.v.option.size'] : [])];
    lockedFilters.forEach(name => root.querySelectorAll('input[name="' + name + '"]').forEach(input => {
      input.disabled = true;
      const group = input.closest('details.js-filter');
      if (group) group.hidden = true;
    }));
    lockedFilters.forEach(name => root.querySelectorAll('facet-remove[data-faf-filter-name="' + name + '"]').forEach(chip => chip.remove()));
    root.querySelectorAll('.active-facets').forEach(group => { group.hidden = !group.querySelector('.active-facets__button'); });
    root.querySelectorAll('[data-faf-search-alternative]').forEach(anchor => {
      const query = intent.alternativeQuery;
      anchor.hidden = !query;
      if (query) { anchor.textContent = strings.browseAll + ' ' + query; anchor.href = config.searchUrl + '?' + new URLSearchParams({ q: query }); }
    });
    const searchButton = root.querySelector('[data-predictive-search-search-for-text]');
    if (searchButton) searchButton.textContent = strings.viewResults.replace('{query}', humanQuery);
    return root;
  }
  function enhanceCards(root, intent) { window.FAFSearchCards?.enhance(root, intent); }
  window.FAFSearch = { plan, toEngineParams, suggestionsURL, normalize, enhanceCards, strings, config };
})();
